export default "__VITE_ASSET__BfFt50VD__"